class archive {
  constructor(){
    let button = document.querySelector('.fetch #the-nav a');
    if(button){
      button.addEventListener('click',this.load);
    }
  }

  load(e){
    e.preventDefault();
    let button = this;
    button.classList.toggle('dd-loading');

    // load the next page
    fetch(this.href).then((e)=>{
      return e.text();
    }).then((res)=>{
      let t = document.implementation.createHTMLDocument();
              t.body.innerHTML = res;
      let c = document.querySelector('#the-posts');
      let nbutton = t.querySelector('#the-nav a');
      let append = t.querySelector('#the-posts');

      c.innerHTML += append.innerHTML;

      if(nbutton){
        button.classList.toggle('dd-loading');
        button.href=nbutton.href;
      } else {
        button.remove();
      }
    }).catch((err)=>{console.log(err);});
  }
}

new archive();
